// Share one in-flight decode between timeline analysis and precise playback.
let cachedUrl;
let cachedDecode;
export function decodeMediaAudio(url, context) {
  if (url === cachedUrl && cachedDecode) return cachedDecode;
  cachedUrl = url;
  const pending = fetch(url).then(response => {
    if (!response.ok) throw new Error('Could not load media audio.');
    return response.arrayBuffer();
  }).then(bytes => context.decodeAudioData(bytes));
  cachedDecode = pending;
  pending.catch(() => { if (cachedDecode === pending) { cachedDecode = null; cachedUrl = null; } });
  return pending;
}

export function audioPeaks(buffer, rate = 100) {
  const count = Math.ceil(buffer.duration * rate);
  const peaks = new Float32Array(count);
  for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
    const samples = buffer.getChannelData(channel);
    for (let i = 0; i < samples.length; i++) {
      const bucket = Math.min(count - 1, Math.floor(i / buffer.sampleRate * rate));
      peaks[bucket] = Math.max(peaks[bucket], Math.abs(samples[i]));
    }
  }
  return {peaks, rate};
}
